





















import SmallText from "@/common/components/atoms/SmallText.vue";
import { Prop, Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    SmallText
  },
  filters: {
    truncate(value: any, length = 20, omission = "...") {
      // if (length === false) {
      //   return value;
      // }
      const stringLength = parseInt(length.toString(), 10);
      const stringOmmision = omission.toString();

      if (value.length <= stringLength) {
        return value;
      }
      return value.substring(0, stringLength) + stringOmmision;
    }
  }
})
export default class JMessageArticlePanelBody extends Vue {
  @Prop({ type: Object, default: [] }) detailData!: any;
  @Prop({ type: Boolean, default: [], required: false })
  unreadCountIsExists!: boolean;

  get name() {
    return this.detailData.name;
  }

  get unreadCount() {
    return this.detailData.unreadCount;
  }

  get content() {
    return this.detailData.content;
  }

  get id() {
    return this.detailData.id;
  }
}
